import { render } from "./NuevaNotaCred.vue?vue&type=template&id=362056b2"
import script from "./NuevaNotaCred.vue?vue&type=script&lang=js"
export * from "./NuevaNotaCred.vue?vue&type=script&lang=js"

import "./NuevaNotaCred.vue?vue&type=style&index=0&id=362056b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__